import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import $ from "jquery";
import NumberGenerationService from '../../services/NumberGenerationService';
import MessageComponent from '../../template/Message';
import tableRequest from '../../models/tableRequest';
import ApiService from '../../services/apiService';
import Loaders from '../../template/Loaders';
// TO Generate NUmber
export default class NumberGeneration extends Component {
    constructor(props) {
        super(props);
        this.NumberGenerationService = new NumberGenerationService();
        this.ApiService = new ApiService();
        this.tblResponse = new tableRequest();
        this.state = {
            visible: false,
            updateLoader: false,
            buttonLabel: 'Submit',
            formHeading: 'Add Number Generation',
            sortOrder: '',
            FromNo: '',
            ToNo: '',
            Qty: '',
            formError: {
                FromNo: null,
                ToNo: null,
                Qty: null,
                prefix: null,

            },
            prefix: '',
            downloadLink: '',
            sales: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found'
        }

        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleChnage = this.handleChnage.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.hideFunc = this.hideFunc.bind(this);
        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.GetFromNo = this.GetFromNo.bind(this);
        this.onSort = this.onSort.bind(this);
    }
    //trigger api function on page call
    componentDidMount() {
        setTimeout(() => {
            this.setState({
                prefix: this.ApiService.getFactoryPrefix()
            });
            this.GetGeneratedNumbers();
        }, 1000);
        $(".p-column-title").on("click", function () {
            $(this)
                .next()
                .removeClass("pi-sort")
                .toggleClass("pi-sort-up")
                .addClass("pi-sort-down");
        });
    }

    // call page event
    onPage(event) {
        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.GetGeneratedNumbers();
        }, 250);
    }

    // get product issue number list data
    GetGeneratedNumbers() {
        this.tblResponse.SortColumn = 'CreatedDt';
        this.tblResponse.Prefix = this.ApiService.getFactoryPrefix();
        this.NumberGenerationService.GetGeneratedNumbers(this.tblResponse).then(data => {
            const resdata = data.data;
            //if response data is not null
            this.setState({
                updateLoader: true
            });
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false,
                    updateLoader: true
                });
            }
            ///if response data is null
            else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false,
                    updateLoader:true

                });
            }
        });
    }

    // show when edit record
    actionTemplate(rowData) {
        const editMode = () => {
            this.setState({
                buttonLabel: 'Update', formHeading: 'Update Number Generation', visible: true,
                FromNo: rowData.FromNo, ToNo: rowData.ToNo, Qty: rowData.Qty
            })
        }
        return <div>
            <Button type="button" icon="pi pi-pencil" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
            <Button type="button" icon="pi pi-trash" className="p-button-danger"></Button>
        </div>;
    }


    //validate form
    //resolved KREP-17
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;
        //to validate each form field with required conditions
        switch (name) {
            case 'FromNo':
                if (value < 1) {
                    IsValid = false;
                    errors.FromNo = "Please enter your from number.";
                } else {
                    if (!value.match(/^[0-9]+$/)) {
                        IsValid = false;
                        errors.FromNo = "Please enter only number.";
                        this.setState({ Qty: 0 })
                    } else {
                        errors.ToNo = null;
                        errors.Qty = null;
                        errors.FromNo = null;
                        const fromNumber = value.trim() === '' ? 0 : parseInt(value.trim());
                        const toNumber = this.state.ToNo.toString().trim() === '' ? 0 : parseInt(this.state.ToNo.toString().trim());
                        if (fromNumber >= 1 && toNumber >= 1) {
                            if (fromNumber <= toNumber) {
                                const qty = (toNumber - fromNumber) + 1;
                                if (qty >= 0) {
                                    this.setState({ Qty: qty })
                                } else {
                                    IsValid = false;
                                    errors.FromNo = "From number should be less than to number.";
                                    this.setState({ Qty: 0 })
                                }
                            } else {
                                IsValid = false;
                                errors.FromNo = "From number should be less than to number.";
                                this.setState({ Qty: 0 })
                            }
                        } else {
                            // IsValid = false;
                            // errors.FromNo = "From number should be less than to number.";
                            this.setState({ Qty: 0 })
                        }
                    }
                }
                break;
            case 'ToNo':
                if (value < 1) {
                    IsValid = false;
                    errors.ToNo = "Please enter To Number.";
                }
                else errors.ToNo = null;
                break;
                case 'prefix':
                    if (value =='null') {
                        IsValid = false;
                        errors.prefix = "Prefix null you can not create number generation.";
                    }
                    else errors.prefix = null;
                    break;
            case 'Qty':
                if (value < 1) {
                    IsValid = false;
                    errors.Qty = "Please enter your quantity.";
                }
                else {
                    if (!value.match(/^[0-9]+$/)) {
                        IsValid = false;
                        errors.Qty = "Please enter only number.";
                        this.setState({ Qty: 0 })
                    } else {
                        errors.ToNo = null;
                        errors.Qty = null;
                        errors.FromNo = null;
                        const qty = value.trim() === '' ? 0 : parseInt(value.trim());
                        const fromNumber = this.state.FromNo.toString().trim() === '' ? 0 : parseInt(this.state.FromNo.toString().trim());
                        if (fromNumber >= 1 && qty >= 1) {
                            const toNumber = (qty + fromNumber) - 1;
                            if (toNumber >= 0) {
                                this.setState({ ToNo: toNumber })
                            } else {
                                IsValid = false;
                                errors.Qty = "To number should be greater than or equal to  from number.";
                                this.setState({ ToNo: 0 })
                            }

                        } else {
                            // IsValid = false;
                            // errors.ToNo = "To number should be greater than from number.";
                            this.setState({ ToNo: 0 })
                        }
                    }
                }
                break;

            default:
                break;
        }

        return IsValid;
    }

    // call when input data on form
    handleChnage(event) {
        const { name, value } = event.target;
        let errors = this.state.formError;

        const isValid = this.validateForm(value, name);
        this.setState({ errors, [name]: value });
    }
    hideFunc() {
        this.setState({
            visible: false, buttonLabel: 'Submit',
            formHeading: 'Add Number Generation'
        })
        this.formReset()
    }

    // form Reset
    formReset() {
        this.setState({
            FromNo: '', ToNo: '', Qty: ''
        });

        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }
    // submit form to api
    submitForm(event) {
        event.preventDefault();
        let isfrmvalid = true;
        let checkerror = this.state.formError;

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            //form is not valid
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
        });
        //form is valid
        if (isfrmvalid) {
            this.setState({ updateLoader: false });
            const formData = {
                FrmNo: this.state.FromNo === '' ? 0 : parseInt(this.state.FromNo),
                ToNo: this.state.ToNo === '' ? 0 : parseInt(this.state.ToNo),
                Qty: this.state.Qty === '' ? 0 : parseInt(this.state.Qty),
                Prefix: this.state.prefix
            }

            setTimeout(() => {
                debugger;
                this.NumberGenerationService.CreateGeneratedNumberStock(formData).then(data => {
                    debugger;
                    const resdata = data.data;
                    //if response code is 200 sucess else error or warning message
                    if (resdata.ResponseCode === '200') {
                        debugger
                        this.refs.child.showSuccess(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false,
                            downloadLink: resdata.downloadLinK,
                            updateLoader: true
                        });
                        this.formReset();
                        this.GetGeneratedNumbers();

                        // const link = document.createElement('a');
                        // link.href = resdata.downloadLinK;
                        // document.body.appendChild(link);
                        // link.click();
                        // document.body.removeChild(link);


                    } else if (resdata.ResponseCode === '400') {
                        this.refs.child.showWarn(resdata.ResponseMessage);
                    } else {
                        this.refs.child.showError(resdata.ResponseMessage);
                    }
                });
            }, 1000);
        }
    }

    // Get Next fromNO
    GetFromNo() {
        this.formReset();
        this.setState({ visible: true })
        const f = {
            Prefix: this.ApiService.getFactoryPrefix()
        };
        this.NumberGenerationService.GetFromNumbers(f).then(data => {
            const resdata = data.data;
            //if ResponseCode is 200 FromNo state will set 
            if (resdata.ResponseCode === '200' && resdata.ResponseData != null) {
                let frmNumber = resdata.ResponseData.FrmNo;
                frmNumber = frmNumber ?? 0 + 1;
                this.setState({ FromNo: '' + frmNumber })
            }
        });
    }

    // set Lazy Loading Values
    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = '1';
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    }

    // search Filter table 
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetGeneratedNumbers();
    }

    // Sort table
    onSort(event) {
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
        const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetGeneratedNumbers();
    }

    // Render html
    //resolved KREP-19
    render() {
        let header = (
            <div style={{ 'textAlign': 'right' }}><a href={this.state.downloadLink} download hidden={!!!this.state.downloadLink}>DownLoad Generated FIle</a>
                <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="30" />
            </div>
        );
        return (
            <>
                <MessageComponent ref="child" />
                <Loaders loader={this.state.updateLoader} />
                <div className="heading">
                    <h1>Number Generation</h1>
                    <Button label="Create Number" icon="pi pi-plus-circle" onClick={this.GetFromNo} />
                </div>

                <DataTable responsive={true} header={header} globalFilter={this.state.globalFilter}
                    emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true}
                    rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]} totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                    onPage={this.onPage} onSort={this.onSort}>
                    <Column field="Prefix" header="Prefix" sortable={true} />
                    <Column field="FrmNo" header="From No." sortable={true} />
                    <Column field="ToNo" header="To No." sortable={true} />
                    <Column field="Qty" header="Quantity" sortable={true} />
                    <Column field="CreatedDate" header="Created Date" sortable={true} />
                </DataTable>

                <Dialog className="popup-modal" header={this.state.formHeading} visible={this.state.visible} modal={true} onHide={this.hideFunc}>
                    <form onSubmit={this.submitForm} className="form-padding">
                        <div className="row">
                            <div className="col-md-12 text-center"><label>Prefix : <strong>{this.state.prefix}</strong></label>
                            {this.state.formError.prefix !== null ?
                                    <div className='error'>{this.state.formError.prefix}</div> : null}
                            </div>
                            
                            <div className="col-md-4 text-right"><label>From No.<span>*</span>:</label></div>
                            <div className="col-md-8 mb-2"><input readOnly type="text" value={this.state.FromNo} onChange={this.handleChnage} className="form-control" name="FromNo" />
                                {this.state.formError.FromNo !== null ?
                                    <div className='error'>{this.state.formError.FromNo}</div> : null}</div>
                            <div className="col-md-4 text-right"><label>Qty<span>*</span>:</label></div>
                            <div className="col-md-8 mb-2">
                                <input type="text" value={this.state.Qty} onChange={this.handleChnage} className="form-control" name="Qty" maxLength={7} />
                                {this.state.formError.Qty !== null ?
                                    <div className='error'>{this.state.formError.Qty}</div> : null}
                            </div>

                            <div className="col-md-4 text-right"><label>To No.<span>*</span>:</label></div>
                            <div className="col-md-8 mb-2">
                                <input type="text" readOnly value={this.state.ToNo} onChange={this.handleChnage} className="form-control" name="ToNo" />
                                {this.state.formError.ToNo !== null ?
                                    <div className='error'>{this.state.formError.ToNo}</div> : null}</div>

                            <div className="col-md-12 text-center">
                                <button type="submit" className="btn btn-primary">{this.state.buttonLabel}</button>
                            </div>
                        </div>
                        <div  >
                            <label>Note: Fields marked as (<span style={{ color: 'red' }}>*</span>) are required</label>
                        </div>

                    </form>
                </Dialog>
            </>
        )
    }
}